import { textDarkV2Theme } from '../../../typography/Text/themes/dark-v2.theme';
import { colorsDark } from '../../../themes/dark-colors';

export const containerDarkV2Theme = {
  variants: {
    neutral: {
      background: colorsDark.gray[0],
      borderColor: colorsDark.gray[300],
      textColor: textDarkV2Theme.color.primary,
    },
    pLight: {
      background: colorsDark.gray[100],
      borderColor: colorsDark.gray[400],
      textColor: textDarkV2Theme.color.faded,
    },
    primary: {
      background: colorsDark.gray[200],
      borderColor: colorsDark.gray[500],
      textColor: textDarkV2Theme.color.primary,
    },
    pMedium: {
      background: colorsDark.gray[300],
      borderColor: colorsDark.gray[600],
      textColor: textDarkV2Theme.color.primary,
    },
    pDark: {
      background: colorsDark.gray[700],
      borderColor: colorsDark.gray[1000],
      textColor: textDarkV2Theme.color.contrast,
    },
    pDeep: {
      background: colorsDark.gray[800],
      borderColor: colorsDark.gray[1000],
      textColor: textDarkV2Theme.color.contrast,
    },
    sLight: {
      background: colorsDark.blue[100],
      borderColor: colorsDark.blue[400],
      textColor: textDarkV2Theme.color.faded,
    },
    secondary: {
      background: colorsDark.blue[200],
      borderColor: colorsDark.blue[500],
      textColor: textDarkV2Theme.color.primary,
    },
    sMedium: {
      background: colorsDark.blue[800],
      borderColor: colorsDark.royalBlue[1000],
      textColor: textDarkV2Theme.color.contrast,
    },
    sDark: {
      background: colorsDark.blue[900],
      borderColor: colorsDark.gray[1000],
      textColor: textDarkV2Theme.color.contrast,
    },
    sDeep: {
      background: colorsDark.blue[1000],
      borderColor: colorsDark.gray[1000],
      textColor: textDarkV2Theme.color.contrast,
    },
    tSoft: {
      background: colorsDark.yellow[200],
      borderColor: colorsDark.yellow[500],
      textColor: textDarkV2Theme.color.primary,
    },
    tLight: {
      background: colorsDark.yellow[300],
      borderColor: colorsDark.yellow[600],
      textColor: textDarkV2Theme.color.primary,
    },
    tertiary: {
      background: colorsDark.yellow[400],
      borderColor: colorsDark.yellow[700],
      textColor: textDarkV2Theme.color.primary,
    },
    tMedium: {
      background: colorsDark.yellow[600],
      borderColor: colorsDark.yellow[900],
      textColor: textDarkV2Theme.color.primary,
    },
    tDark: {
      background: colorsDark.yellow[700],
      borderColor: colorsDark.yellow[1000],
      textColor: textDarkV2Theme.color.contrast,
    },
    lightError: {
      background: colorsDark.red[200],
      borderColor: colorsDark.red[500],
      textColor: textDarkV2Theme.color.primary,
    },
    error: {
      background: colorsDark.red[500],
      borderColor: colorsDark.red[800],
      textColor: textDarkV2Theme.color.contrast,
    },
    lightSuccess: {
      background: colorsDark.green[200],
      borderColor: colorsDark.green[500],
      textColor: textDarkV2Theme.color.primary,
    },
    success: {
      background: colorsDark.green[500],
      borderColor: colorsDark.green[800],
      textColor: textDarkV2Theme.color.primary,
    },
    darkSuccess: {
      background: colorsDark.green[700],
      borderColor: colorsDark.green[1000],
      textColor: textDarkV2Theme.color.contrast,
    },
    lightRoyal: {
      background: colorsDark.royalBlue[200],
      borderColor: colorsDark.royalBlue[500],
      textColor: textDarkV2Theme.color.primary,
    },
    royal: {
      background: colorsDark.royalBlue[1000],
      borderColor: colorsDark.royalBlue[700],
      textColor: textDarkV2Theme.color.contrast,
    },
  },
};
